export default __webpack_public_path__ + "8700caaa9685962da082c6e6ade9860c.png";